export default __webpack_public_path__ + "static/media/visible_password.92bcbc0b.svg";